export default "__VITE_ASSET__G$XifHFJ__"